module.exports = __webpack_public_path__ + "operace-usnich-boltcu_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_2_before.jpg
// module id = 1214
// module chunks = 0